"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var i18next_1 = __importDefault(require("i18next"));
var react_1 = require("@fluentui/react");
var types_1 = require("./types");
exports.isRtlLanguage = function (lang) {
    return lang === 'ar';
};
// TypeScript infers that this function is returning SendMessageAction
function changeLanguage(language) {
    react_1.setRTL(exports.isRtlLanguage(language), true);
    i18next_1.default.changeLanguage(language);
    return {
        type: types_1.CHANGE_LANGUAGE,
        payload: language,
    };
}
exports.changeLanguage = changeLanguage;
//# sourceMappingURL=action.js.map